import { BetSlipMode } from "../../types/enums";

type StakesMap = Record<string, number>;

function getStakeKey(eventId: number, mode: BetSlipMode): string {
  return mode === BetSlipMode.Combo ? "combo" : String(eventId);
}

function buildSelectionSegment(
  selection: IBetSlipSelection,
  mode: BetSlipMode,
  stakes: StakesMap,
): string {
  const stake = stakes[getStakeKey(selection.eventId, mode)] ?? "";
  return `${selection.eventId}:${selection.oddPrice}:${stake}`;
}

function buildBetBuilderSegment(
  totalOdd: IBetBuilderTotalOdds,
  mode: BetSlipMode,
  stakes: StakesMap,
): string {
  const stake = stakes[getStakeKey(totalOdd.eventId, mode)] ?? "";
  return `${totalOdd.eventId}:${totalOdd.odd}:${stake}`;
}

function buildSelectionsVersion(
  mode: BetSlipMode,
  selections: IBetSlipSelection[],
  stakes: StakesMap,
): string {
  const parts = selections.map((s) => buildSelectionSegment(s, mode, stakes));
  return `${mode}-${parts.join("-")}`;
}

function appendBetBuilderVersion(
  base: string,
  totalOdds: IBetBuilderTotalOdds[],
  mode: BetSlipMode,
  stakes: StakesMap,
): string {
  if (!totalOdds.length) return base;
  const parts = totalOdds.map((t) => buildBetBuilderSegment(t, mode, stakes));
  return base + parts.join("-");
}

export function computeBsVersion(
  betSlipState: IBetSlipState,
  stakes: StakesMap = {},
): string {
  const { mode, selections, betBuilderState } = betSlipState;
  const base = buildSelectionsVersion(mode, selections, stakes);
  return appendBetBuilderVersion(
    base,
    betBuilderState?.totalOdds ?? [],
    mode,
    stakes,
  );
}
